module.exports = __webpack_public_path__ + "static/media/course04.65faaa48.png";